import {
  Apps as AppsIcon,
  Folder as FolderIcon,
  DesktopWindows as DesktopIcon,
  Download as DownloadIcon,
  Help as HelpIcon,
  Settings as SettingsIcon,
  Dashboard as DashboardIcon,
  ConfirmationNumber as TicketIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
} from '@mui/icons-material'

export interface NavItem {
  labelKey: string
  path: string
  icon: React.ElementType
  roles: string[]
}

export const navItems: NavItem[] = [
  { labelKey: 'navigation.apps', path: '/apps', icon: AppsIcon, roles: ['user', 'admin', 'operator'] },
  { labelKey: 'navigation.files', path: '/files', icon: FolderIcon, roles: ['user', 'admin', 'operator'] },
  { labelKey: 'navigation.sessions', path: '/sessions', icon: DesktopIcon, roles: ['user', 'admin', 'operator'] },
  { labelKey: 'navigation.downloads', path: '/downloads', icon: DownloadIcon, roles: ['user', 'admin', 'operator'] },
  { labelKey: 'navigation.help', path: '/help', icon: HelpIcon, roles: ['user', 'admin', 'operator'] },
  { labelKey: 'navigation.settings', path: '/settings', icon: SettingsIcon, roles: ['user', 'admin', 'operator'] },
  { labelKey: 'navigation.dashboard', path: '/admin/dashboard', icon: DashboardIcon, roles: ['admin'] },
  { labelKey: 'navigation.tickets', path: '/admin/tickets', icon: TicketIcon, roles: ['admin'] },
  { labelKey: 'navigation.adminSettings', path: '/admin/settings', icon: AdminPanelSettingsIcon, roles: ['admin'] },
]
